import React from 'react'
import PropTypes from 'prop-types'
import { red } from '@material-ui/core/colors'
import { Box, ListItem, ListItemIcon, ListItemText, Grid, Typography, ListItemSecondaryAction, Divider } from '@mui/material'
import capitalize from 'lodash/capitalize'
import PaymentStatusChip, { PAYMENT_STATUS_COLORS } from 'components/chip/PaymentStatusChip'
import HHDisplayMoney from 'components/HHDisplayMoney'
import T from 'T'

const PaymentListItem = ({
  accountNumber = '',
  accountType = '',
  capitalizeTransactionStatus = '',
  date = '',
  isAccountCredit = false,
  isCheckOther = false,
  isNotLast = false,
  paymentMethodImage = '',
  paymentMethodName = '',
  transactionAmountCents = '',
  surchargeAmountCents = 0,
  checkValue = '',
  paymentNumber,
  onClick,
}) => {
  const colorMap = capitalizeTransactionStatus in PAYMENT_STATUS_COLORS ? PAYMENT_STATUS_COLORS[capitalizeTransactionStatus] : red
  const secondaryText = (isCheckOther || isAccountCredit) && checkValue
  return (
    <>
      <Box onClick={onClick} sx={{ cursor: paymentNumber ? 'pointer' : 'default' }} my={1.5} mx={2}>
        <ListItem disablePadding disableGutters>
          <ListItemIcon sx={{ minWidth: '130px' }}>
            {capitalizeTransactionStatus && <PaymentStatusChip status={capitalizeTransactionStatus} />}
          </ListItemIcon>
          <ListItemText
            primary={
              <Grid container>
                <Grid item>
                  <Box mr={2} component="img" src={paymentMethodImage} alt="" />
                </Grid>
                <Grid item xs>
                  <Box display="flex" flexDirection="column">
                    <Typography>{accountType && accountNumber ? `${accountType} •••• ${accountNumber}` : paymentMethodName}</Typography>
                    {secondaryText && <Typography variant="caption">{secondaryText}</Typography>}
                  </Box>
                </Grid>
              </Grid>
            }
          />
          <ListItemSecondaryAction>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography variant="h3" display="flex" alignItems="center" justifyContent="flex-end" fontWeight={700}>
                <HHDisplayMoney value={transactionAmountCents} />
              </Typography>
              {surchargeAmountCents > 0 && (
                <Typography variant="caption" color="text.secondary" display="flex" alignItems="center">
                  {`${T.SURCHARGE}: `}
                  <HHDisplayMoney value={surchargeAmountCents} />
                </Typography>
              )}
            </Box>
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem disablePadding disableGutters>
          <ListItemText
            primary={
              <Typography
                sx={{
                  color: colorMap[600],
                }}
                variant="caption"
                fontWeight={700}
              >
                {`${T.POSTED}: ${date}`}
              </Typography>
            }
          />
          <ListItemSecondaryAction>
            <Typography display="flex" alignItems="center" justifyContent="flex-end" variant="caption">
              {`${capitalize(T.TRANSACTION_DATE)}: `}
              {date}
            </Typography>
          </ListItemSecondaryAction>
        </ListItem>
      </Box>
      {isNotLast && <Divider />}
    </>
  )
}

PaymentListItem.propTypes = {
  accountNumber: PropTypes.string,
  accountType: PropTypes.string,
  capitalizeTransactionStatus: PropTypes.string,
  date: PropTypes.string,
  isAccountCredit: PropTypes.bool,
  isCheckOther: PropTypes.bool,
  isNotLast: PropTypes.bool,
  paymentMethodImage: PropTypes.string,
  paymentMethodName: PropTypes.string,
  transactionAmountCents: PropTypes.string,
  surchargeAmountCents: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checkValue: PropTypes.string,
  paymentNumber: PropTypes.number,
  onClick: PropTypes.func.isRequired,
}

export default PaymentListItem
